import React from "react";
import { AppBar, Box, IconButton, Toolbar, Button, Drawer, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ReusableModal from "../ReusableModal/ReusableModal";
import "./Navbar.css";
import AbsyzLogo from "../../assessts/images/ABSYZ-LOGO.png";
import constants from "../../utils/constants";

const Navbar = ({ name }: { name: string }) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [drawerOpen, setDrawerOpen] = React.useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleOpenLogoutModal = () => {
    setOpen(true);
  };

  const toggleDrawer = (open: boolean) => {
    setDrawerOpen(open);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const navlinks = [
    { name: "Case Studies", path: constants.navigationUrls.caseStudies },
    { name: "Videos", path: constants.navigationUrls.videos },
    { name: "Industry Tracks", path: constants.navigationUrls.industryTrackContent },
    // { name: "Certifications", path: constants.navigationUrls.certifications },
    { name: "Reports", path: constants.navigationUrls.reports },
    { name: "Users", path: constants.navigationUrls.users },
  ];

  return (
    <>
      <AppBar position="static">
        <Toolbar
          sx={{
            background: "#4D8FAC",
            display: "flex",
            justifyContent: "space-between",
            minHeight: { xs: "56px", sm: "64px" },
            padding: { xs: "8px 16px", sm: "8px 24px" },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <img
              src={AbsyzLogo}
              alt="absyz-logo"
              style={{ height: "90px", borderRadius: "25px", margin: "-10px" }}
              className="absyz-logo"
            />

            {/* Desktop Navigation */}
            <Box className="desktop-nav" sx={{ display: { xs: "none", md: "flex" }, gap: "10px", flexDirection: "row", flexWrap: "nowrap", alignItems: "center" }}>
              {navlinks.map((link, index) => (
                <Button
                  key={index}
                  onClick={() => navigate(link.path)}
                  sx={{
                    color: location.pathname === link.path ? "#e3dddc" : "white",
                    textTransform: "none",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                  }}
                >
                  {link.name}
                </Button>
              ))}
              
            </Box>
            
          </Box>
          <Box>

              </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* Hamburger Menu for Mobile */}
            <IconButton
              onClick={() => toggleDrawer(true)}
              sx={{ color: "white", display: { xs: "block", md: "none" } }}
            >
              <MenuIcon />
            </IconButton>
<IconButton onClick={handleOpenLogoutModal} sx={{ color: "white",display: { xs: "none", md: "block" } }}>
                <LogoutIcon />
              </IconButton>
            
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => toggleDrawer(false)}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: "250px",
            background: "#4D8FAC",
          },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}>
          <IconButton onClick={() => toggleDrawer(false)} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {navlinks.map((link, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={() => handleNavigation(link.path)}
                sx={{
                  backgroundColor: location.pathname === link.path ? "rgba(255,255,255,0.1)" : "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.2)",
                  },
                }}
              >
                <ListItemText
                  primary={link.name}
                  sx={{
                    color: location.pathname === link.path ? "#e3dddc" : "white",
                    fontWeight: location.pathname === link.path ? "bold" : "normal",
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
          <ListItemText primary="Logout" sx={{ color: "white", fontWeight: "bold" ,paddingLeft:"18px"}} onClick={handleOpenLogoutModal} />
        </List>
        
       
      </Drawer>

      <div style={{ padding: "20px 0px 25px 38px" }} className="admin-content">
        <Outlet />
      </div>
      {open && <ReusableModal open={open} setOpen={setOpen} type="logout" />}
    </>
  );
};

export default Navbar;